export const selectDashboardDetails = (state) => state.dashboard;
